module.exports = __webpack_public_path__ + "static/img/Frame 1010104364@2x.ef2233e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/Frame 1010104364@2x.png
// module id = VleP
// module chunks = 1